// src/components/redux/actions.js

import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './actionTypes';

export const loginSuccess = (userData) => {
  return {
    type: LOGIN_SUCCESS,
    payload: { userData }
  };
};

export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: error
  };
};

export const logout = () => {
  return { type: LOGOUT };
};
